import { $ } from "venuescanner-js/tools/elemental";
import store from "venuescanner-js/utils/storeWithCompression";
import { GalleryViewer } from "./gallery.viewer.widget";
import "venuescanner-scss/stylesheets/widgets/_gallery2.scss";

export const Swiper = function (pane) {
  pane = $(pane);
  pane.addClass("swiper-attached");
  this.GalleryViewer = new GalleryViewer(pane);
  this.idleTime = 20000;
  this.autoInterval = 8000;
  this.pane = pane;
  this.touchContainer = this.pane.find(".swiper-pane-container");
  this.panel = this.pane.find(".swiper-pane-container>.swiper-pane");
  this.blur = this.pane.find(".blur-pane");
  this.thumbnails = this.blur.get().length
    ? this.pane.parent().find(".thumbnail-pane")
    : null;
  this.settings = {
    itemsAreFullWidth: {
      title: "The items in the scroll are 100% width",
      type: "boolean",
      value: true,
    },
    attractRadius: {
      title:
        "Distance from an item where it starts to attract as percentage of average item width",
      type: "integer",
      value: 200,
    },
    attraction: {
      title: "Acceleration to an item at 0 distance",
      type: "integer",
      value: 600,
    },
    persistentFriction: {
      title: "Reduce the speed by % per second",
      type: "integer",
      value: 200,
    },
    bounce: {
      title: "Bounce on limit efficiency",
      type: "float",
      value: 0.2,
    },
    swipeMinX: {
      title: "Swipe distance to determine the action is a swipe",
      type: "integer",
      value: 20,
    },
    scrollMinY: {
      title: "Swipe distance to determine the action is a scroll",
      type: "integer",
      value: 20,
    },
  };

  for (let k in this.settings) {
    if (this.pane.attr(k)) {
      if (
        typeof this.settings[k].value == "function" &&
        typeof this.pane.attr(k)
      ) {
        this.settings[k].value = this.pane.attr(k);
      } else {
        switch (this.settings[k].type) {
          case "text":
            this.settings[k].value = "" + this.pane.attr(k);
            break;
          case "boolean":
            this.settings[k].value = this.pane.attr(k) == true;
            break;
          case "integer":
            this.settings[k].value = parseInt(this.pane.attr(k));
            break;
          case "float":
            this.settings[k].value = parseFloat(this.pane.attr(k));
            break;
          default:
            break;
        }
      }
    }
  }
  this.events = {
    initial: {
      pageX: null,
      pageY: null,
    },
    last: {
      pageX: null,
      pageY: null,
    },
    speed: 0,
    acceleration: 0,
    lastTime: 0,
    left: parseFloat(this.panel.css("left")),
    currentleft: parseFloat(this.panel.css("left")),
  };
  this.cursor = function (e) {
    return e.type.substr(0, 5) == "touch" ? e.changedTouches[0] : e;
  };
  this.isDragging = false;
  this.attracted = true;
  this.persisting = false;
  this.persist = function () {
    try {
      if (!this.isDragging && this.persisting) {
        this.detectItems();
        let now = new Date().getTime();
        let delay = now - this.events.lastTime;
        this.events.lastTime = now;
        let a = this.acceleration();
        let up = this.events.speed >= 0;
        this.events.speed -= (a.a * delay) / 1000;
        let reverse = this.events.speed >= 0 != up;
        if (Math.abs(this.events.speed) > 0.1 || Math.abs(a.a) > 0.1) {
          if (a.distance < 2 && reverse) {
            this.events.currentleft = a.closest;
            this.panel.css({
              left: this.settings.itemsAreFullWidth.value
                ? `-${100 * this.currentindex}%`
                : `${this.events.currentleft}px`,
            });
            if (this.thumbnailsPane !== undefined) {
              this.thumbnailsPane.css({
                left: `-${100 * this.currentindex}%`,
              });
            }
            this.persisting = false;
          } else {
            if (this.attracted) {
              let friction =
                ((this.settings.persistentFriction.value / 100) * delay) / 1000;
              this.events.speed -= friction * this.events.speed;
            }
            this.events.currentleft += (this.events.speed * delay) / 1000;
            const rounded = Math.round(this.events.currentleft);
            this.panel.css({ left: `${rounded}px` });
            // console.log(this.events.currentleft)
            // if (this.thumbnailsPane) {
            //   this.thumbnailsPane.css({
            //     left: (100 * ((this.events.currentleft / this.panel.width()) + 0)) + '%'
            //   })
            // }
            if (this.persisting) {
              setTimeout(() => {
                window.requestAnimationFrame(() => {
                  this.persist();
                });
              }, 30);
            }
          }
          // if (scroller !== undefined) scroller.process(this.panel)
        }
      }
    } catch (e) {
      console.error(e);
    }
  };
  this.bounced = false;
  this.currentindex = null;
  this.key = null;
  this.getKey = function () {
    if (
      this.key === null &&
      this.pane.get(0).id !== undefined &&
      this.pane.get(0).id != ""
    )
      this.key = "swiper" + this.pane.get(0).id.replace(/[^a-z^0-9]/gi, "_");
    return this.key;
  };
  this.moveToIndex = function (i, fromIdle) {
    this.panel.css({
      transition: "left 0.5s",
    });
    if (i < 0) i = this.items.length - 1;
    if (i >= this.items.length) i = 0;
    this.persisting = false;
    // if (this.thumbnailsPane !== undefined) {
    //   this.thumbnailsPane.animate({
    //     left: (-100 * i) + '%'
    //   })
    // }
    this.panel.css({
      left: this.settings.itemsAreFullWidth.value
        ? `-${100 * i}%`
        : `-${this.items[i]}px`,
    });
    this.index = i;
    // if (scroller !== undefined) scroller.process(this.panel)
  };

  this.leftButton = this.pane.find(".swiper-left").click((e) => {
    e.preventDefault();
    e.stopPropagation();
    this.moveToIndex(this.currentindex - 1);
    return false;
  });

  const images = document.querySelectorAll(".carousel__image__cta");
  images.forEach((image) =>
    image.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      // console.log(image.getAttribute('data-image-index'))
      this.moveToIndex(image.getAttribute("data-image-index"));
      return false;
    })
  );

  this.rightButton = this.pane.find(".swiper-right").click((e) => {
    e.preventDefault();
    e.stopPropagation();
    this.moveToIndex(this.currentindex + 1);
    return false;
  });

  Object.defineProperty(this, "index", {
    get: function () {
      if (this.currentindex === null) {
        this.currentindex = 0;
        let key = this.getKey();
        if (key !== null) {
          if (store !== undefined && store.get(key) !== undefined) {
            this.currentindex = parseInt(store.get(key));
          } else if (
            typeof localStorage != "undefined" &&
            localStorage[key] !== undefined
          ) {
            this.currentindex = parseInt(localStorage[key]);
          }
        }

        this.blur
          .find("div:nth-child(" + (this.currentindex + 1) + ")")
          .addClass("on")
          .siblings()
          .removeClass("on");
      }
      return this.currentindex;
    },
    set: function (v) {
      if (this.currentindex != v) {
        this.currentindex = parseInt(v);
        let key = this.getKey();
        if (store !== undefined) {
          store.set(key, this.currentindex.toString());
        } else if (typeof localStorage != "undefined") {
          localStorage[key] = this.currentindex;
        }
        this.blur
          .find("div:nth-child(" + (this.currentindex + 1) + ")")
          .addClass("on")
          .siblings()
          .removeClass("on");
      }
    },
  });
  this.acceleration = function () {
    let a = 0;
    let aCount = 0;
    let count = 0;
    let pos = 0;
    let closestPosition = null;
    let closestDistance = 100000000;
    let index = null;
    for (let i in this.items) {
      if (i >= 0) {
        pos += this.items[i];
        count++;
        const dx = this.events.currentleft + this.items[i];
        if (closestPosition === null || closestDistance > Math.abs(dx)) {
          closestDistance = Math.abs(dx);
          closestPosition = this.items[i];
          index = i;
        }
        if (
          Math.abs(dx) <
          (this.itemWidth * this.settings.attractRadius.value) / 100
        ) {
          aCount++;
          a += this.accCalc(dx);
        }
      }
    }
    this.index = index;
    if (this.events.currentleft > -this.items[0] && this.events.speed > 0) {
      this.events.speed = -(this.settings.bounce.value * this.events.speed);
      return { a: 0, closest: closestPosition, distance: closestDistance };
    } else if (
      this.events.currentleft < -this.items[this.items.length - 1] &&
      this.events.speed < 0
    ) {
      this.events.speed = -(this.settings.bounce.value * this.events.speed);
      return { a: 0, closest: closestPosition, distance: closestDistance };
    } else {
      if (aCount == 0) {
        pos /= count;
        this.attracted = false;
        if (!this.bounced) {
          this.bounced = true;
          this.events.speed = -(this.settings.bounce.value * this.events.speed);
        }
        return { a: 0, closest: closestPosition, distance: closestDistance };
      } else {
        this.bounced = false;
      }
    }
    this.attracted = true;
    return { a: a, closest: closestPosition, distance: closestDistance };
  };
  this.accCalc = function (dx) {
    let ax =
      this.settings.attraction.value /
      Math.pow((this.itemWidth * this.settings.attractRadius.value) / 100, 2);
    ax *= Math.pow(
      (this.itemWidth * this.settings.attractRadius.value) / 100 - Math.abs(dx),
      2
    );
    if (dx < 0) ax = -ax;
    return ax;
  };
  this.items = null;
  this.itemWidth = 100;
  this.detectItems = function () {
    if (this.items === null) {
      let w = 0;
      let wCount = 0;
      let add = true;
      let items = this.panel.children();
      let last = $(items[items.length - 1]);
      let l = this.panel.offset().left;
      let maxl = last.offset().left - l + last.width() - this.pane.width();
      this.items = [];
      items.forEach((e) => {
        w += $(e).width();
        wCount++;
        // console.log($(e).offset(), l)
        let dl = $(e).offset().left - l;
        if (add) this.items.push(dl);
        if (dl > maxl) add = false;
      });
      this.itemWidth = w / wCount;
    }
  };
  this.elementParent = function (target, types, stopAt) {
    if (types instanceof Array) {
      if (types.indexOf(target.tagName.toLowerCase()) >= 0) return target;
      if (target === stopAt) return false;
      return this.elementParent(target.parentElement, types, stopAt);
    }
    return false;
  };
  this.temporaryClickRemove = function (target, trigger) {};
  this.move = (e) => {
    // console.log(e)
    let event = this.cursor(e);
    let now = new Date().getTime();
    let delay = now - this.events.lastTime;
    let distance = event.screenX - this.events.last.pageX;
    let scrollY = event.screenY - this.events.initial.pageY;
    this.events.speed = distance / (delay / 1000);
    if (Math.abs(scrollY) > this.settings.scrollMinY.value) {
      let ds = event.screenY - this.events.last.pageY;
      window.scrollBy(0, -ds);
    }
    this.events.last.pageX = event.screenX;
    this.events.last.pageY = event.screenY;
    this.events.currentleft += distance;

    if (this.events.currentleft > -this.items[0]) {
      this.events.currentleft = -this.items[0];
      this.events.speed = 0;
    }
    if (this.events.currentleft < -this.items[this.items.length - 1]) {
      this.events.currentleft = -this.items[this.items.length - 1];
      this.events.speed = 0;
    }
    this.events.lastTime = now;
    this.panel.css({ left: `${this.events.currentleft}px` });
    if (this.thumbnailsPane) {
      this.thumbnailsPane.css({
        left: 100 * (this.events.currentleft / this.panel.width() + 0) + "%",
      });
    }
  };
  this.end = (e) => {
    try {
      let event = this.cursor(e);
      this.isDragging = false;
      this.persisting = true;
      this.persist();
      this.events.last.pageX = event.screenX;
      this.events.last.pageY = event.screenY;
      if (e.type.substr(0, 5) === "touch") {
        this.touchContainer.get(0).removeEventListener("touchmove", this.move);
        this.touchContainer.get(0).removeEventListener("touchend", this.end);
      } else {
        this.touchContainer.get(0).removeEventListener("mousemove", this.move);
        this.touchContainer.get(0).removeEventListener("mouseup", this.end);
        this.touchContainer.get(0).removeEventListener("mouseleave", this.end);
      }
    } catch (e) {
      console.error(e);
    }
    return false;
  };
  let start = (e) => {
    if (
      $(e.target).hasClass("noSwiper") ||
      $(e.target).parents(".noSwiper").get().length
    )
      return;
    const clickable = this.elementParent(
      e.target,
      ["a", "button", "input", "textarea", "select"],
      this.pane.get(0)
    );
    if (!clickable || clickable.parentElement !== this.pane.get(0)) {
      this.panel.css({
        transition: "",
      });
      this.isDragging = true;
      this.items = null;
      this.detectItems();
      this.bounced = false;
      e.preventDefault();
      let event = this.cursor(e);
      this.events.initial.pageX = this.events.last.pageX = event.screenX;
      this.events.initial.pageY = this.events.last.pageY = event.screenY;
      this.events.currentleft = this.events.left = this.panel.get(0).offsetLeft;
      this.events.speed = 0;
      this.events.lastTime = new Date().getTime();
      if (e.type.substr(0, 5) === "touch") {
        this.touchContainer
          .get(0)
          .addEventListener("touchmove", this.move, { passive: true });
        this.touchContainer
          .get(0)
          .addEventListener("touchend", this.end, { passive: true });
      } else {
        this.touchContainer
          .get(0)
          .addEventListener("mousemove", this.move, { passive: true });
        this.touchContainer
          .get(0)
          .addEventListener("mouseup", this.end, { passive: true });
        this.touchContainer
          .get(0)
          .addEventListener("mouseleave", this.end, { passive: true });
      }
    }
    return false;
  };
  this.touchContainer
    .get(0)
    .addEventListener("touchstart", start, { passive: true, capture: true });
  this.touchContainer
    .get(0)
    .addEventListener("mousedown", start, { passive: true, capture: true });
  let setScroll = () => {
    if (this.currentindex === null) {
      this.currentindex = 0;
      this.items = null;
      this.detectItems();
      this.panel.find("img").each((e, i) => {
        e.blurPanel = $("<div></div>");
        if (e.tagName === "IMG") {
          if (e.src) {
            e.blurPanel
              .css({
                backgroundImage: 'url("' + e.src + '")',
              })
              .addClass("lazyload-loaded");
            if (i === 0) {
              setTimeout(() => {
                e.blurPanel.addClass("on");
              }, 500);
            }
            $(e).addClass("lazyload-loaded");
          }
          let src = e.getAttribute("data-src");
          if (typeof src != "string") src = e.src;
          if (this.thumbnails && this.thumbnails.get().length) {
            if (this.thumbnailsPane === undefined) {
              this.thumbnailsPane = $("<div></div>");
              this.thumbnails.append(this.thumbnailsPane);
            }
            let _slider = this;
            src = src.replace(/(main\-|med\-)/, "min-");
            let thumb = $("<button></button>")
              .attr("type", "button")
              .click(function () {
                _slider.moveToIndex($(this).prevAll().get().length);
              });
            let img = document.createElement("img");
            $(img).bind("load", function () {
              thumb
                .css({
                  backgroundImage: 'url("' + src.replace(/med_/, "min_") + '")',
                })
                .addClass("thumb-loaded");
            });
            img.src = src;
            this.thumbnailsPane.append(thumb);
          }
        }
        this.blur.append(e.blurPanel);
      });
      if (this.items.length > this.currentindex) {
        this.panel.css({
          left: -this.items[this.currentindex],
        });
        if (this.thumbnailsPane !== undefined) {
          this.thumbnailsPane.css({
            left: -100 * this.currentindex + "%",
          });
        }
      }
    }
  };
  setScroll();
  $(window).bind("resize", () => {
    setScroll();
  });
};
